/** Survives AuthScreen remount when the register email link changes the URL. */

const pendingRegisterKey = 'dinodash.pendingRegister';

type PendingRegister = {
  email: string;
  password: string;
};

export function savePendingRegister(email: string, password: string): void {
  try {
    const payload: PendingRegister = { email: email.trim(), password };
    sessionStorage.setItem(pendingRegisterKey, JSON.stringify(payload));
  } catch {
    // Private mode / quota — deep-link restore may ask for password again.
  }
}

export function readPendingRegisterPassword(email: string): string | null {
  try {
    const raw = sessionStorage.getItem(pendingRegisterKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingRegister;
    if (parsed.email !== email.trim() || !parsed.password) return null;
    return parsed.password;
  } catch {
    return null;
  }
}

export function clearPendingRegister(): void {
  try {
    sessionStorage.removeItem(pendingRegisterKey);
  } catch {
    // ignore
  }
}
